///客户端是pc端还是移动端
export function isPC(){
    const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|huawei|Android|oppo|vivo|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    return !flag
}
//设置數组字符串首字母大写
export function setFirstLetterUpperCase(arr) {
  let newArr = []
  for (let i = 0; i < arr.length; i++) {
    newArr.push({
      id: arr[i].id,
      name:arr[i].name.replace(arr[i].name.substring(0, 1), arr[i].name.substring(0, 1).toUpperCase())
    })
  }
  return newArr
}

//下载binary文件
export function downloadFile(data,filename) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    // 创建一个临时的 URL
    const url = URL.createObjectURL(blob);
    // 创建一个下载链接
    const a = document.createElement('a');
    a.href = url;
    a.download = filename; // 设置下载文件的名称
    // 触发点击事件来下载文件
    document.body.appendChild(a);
    a.click();
    // 清理临时 URL
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

//获取文件名
export function getFileName(url) {
  let fileName = ''
  if (url) {
    const index = url.lastIndexOf('/')
    fileName = url.substring(index + 1)
  }
  return fileName
}

///數字小數点
export function toFixed(number, m) {
    if (typeof number !== "number") {
      throw new Error("number不是數字");
    }
    let result = Math.round(Math.pow(10, m) * number) / Math.pow(10, m);
    result = String(result);
    if (result.indexOf(".") == -1) {
      if (m != 0) {
        result += ".";
        result += new Array(m + 1).join("0");
      }
    } else {
      let arr = result.split(".");
      if (arr[1].length < m) {
        arr[1] += new Array(m - arr[1].length + 1).join("0");
      }
      result = arr.join(".");
    }
    return result;
  }
  
  export function integralComputation(point, pet){
       
    return  Math.round(point / pet) 
     
  }
  export function  Mathround(value){
       
    return  parseInt(value) 
     
  }
  
  ///判断輸入值是否为正整數
export function isPositiveInteger(s){
  
  if((/(^[1-9]\d*$)/.test(s))) {
     return  true
  } else {
    return false
  }
}    

///转换为了大写字符
export function stringToUpperCase(value){
   return value.toUpperCase()
}

//值为空
export function isValueEmpty(value){
  if(value == null || value == undefined || value == ''){
    return true
  }else{
    return false
  }
}
